export enum NotificationsPermissionsE {
  Granted = 'granted',
  Denied = 'denied',
  Default = 'default',
}

export enum NotificationActionsE {
  TicketCreated = 'TicketCreated',
  TicketClosed = 'TicketClosed',
  TicketReOpened = 'TicketReOpened',
  TicketApproved = 'TicketApproved',
  TicketApprovalRequested = 'TicketApprovalRequested',
  TicketMessageSent = 'TicketMessageSent',
  TicketAttachmentUploaded = 'TicketAttachmentUploaded',
  MessageBoardUpdated = 'MessageBoardUpdated',
  /**
   * Internal user assigned a WIP Repair Order to the dealer.
   * Server message: "A Repair Order requires your attention" (WARR-10276).
   */
  WipAssignedToDealer = 'WipAssignedToDealer',
  /**
   * Internal user requested dealer action on a WIP Repair Order.
   * Server message: "Action required on a WIP Repair Order" (WARR-10276).
   */
  WipActionRequiredFromDealer = 'WipActionRequiredFromDealer',
}

/**
 * Notification kinds that originate from the WIP feature and should deep-link to the WIP tab
 * (instead of the ticket details page) when clicked from the bell list or the browser push.
 */
export const WIP_NOTIFICATION_ACTION_TYPES: readonly NotificationActionsE[] = [
  NotificationActionsE.WipAssignedToDealer,
  NotificationActionsE.WipActionRequiredFromDealer,
];
